import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { grey, unityGrey } from './colors';

export const border = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['border'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          prominent: unityGrey[300],
          subtle: unityGrey[100],
        }
      : {
          prominent: unityGrey[600],
          subtle: unityGrey[900],
        };
  }

  return mode === 'light'
    ? {
        prominent: grey[300],
        subtle: grey[150],
      }
    : {
        prominent: grey[600],
        subtle: grey[850],
      };
};
